export default __webpack_public_path__ + "static/media/power_spectrum_norm.d4a45808.webp";